import React from 'react';
import { Nav, Container, Navbar } from 'react-bootstrap';
import logo from '../../RPLogotagline-High-Res.png';
import { authContext } from "../../adalConfig";
import axios from "axios";
import { Link } from 'react-router-dom';
import { getToken } from '../../adalConfig';

const logout = props => {
    const url = process.env.REACT_APP_LOGSIGNOUT
    let headers = {
        'Content-Type': 'multipart/form-data'
    };

    headers["Authorization"] = `Bearer ${getToken()}`;

    const form = new FormData();
    const userid = localStorage.getItem('id');
    form.append('userid', userid);

    for (var pair of form.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
    }

    axios.post(url, form, { headers: headers }).then((response) => {
        localStorage.clear()
        authContext.logOut()
    }).catch((error) => {
        console.log(error)
        localStorage.clear()
        authContext.logOut()
    });
}

const Headers = props => {

    let userMenu =
        <div>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Navbar.Text>
                    <span className="text-white my-auto">{props.user}</span>
                </Navbar.Text>
                <Nav.Link
                    className="text-white my-auto"
                    to={'/'}
                    onClick={logout}>
                    Logout
                </Nav.Link>
            </Navbar.Collapse>
        </div>

    return (
        <Navbar expand="lg" variant="light" className="bg-brandcolor">
            <Container fluid="xl">
                <Navbar.Brand>
                    <Link to="/">
                        <img src={logo} alt="rp logo" />
                    </Link>
                </Navbar.Brand>
                <h4 className="d-block d-lg-none rp-navbar-title text-white text-center w-50 mx-auto">Photo System</h4>
                <h4 className="d-none d-lg-block rp-navbar-title text-white text-center w-75 mx-auto">Photo System</h4>
                {
                    props.user ? userMenu : null
                }
            </Container>
        </Navbar>
    );
}

export default Headers;
